console.log('🔍 Wishlist reposition script loaded - Version 3.1 (Anti-duplicate)!');

var wishlistRepositioned = false;
var repositionAttempts = 0;
var maxAttempts = 20;
var isProcessing = false; // 新增：防止同时执行多次

// 查找 wishlist widget
function findWishlistWidget() {
  var selectors = [
    '.gw-wl-add-to-wishlist-product-page-widget',
    '#shopify-block-Ae115eTac21VWHp4K__growave_loyalty_wishlist_block_product_fave_button_MHGrT6',
    '[class*="gw-wl"]',
    '[id*="growave_loyalty_wishlist"]'
  ];
  
  for (var i = 0; i < selectors.length; i++) {
    var widget = document.querySelector(selectors[i]);
    if (widget) {
      console.log('✅ Found wishlist widget:', selectors[i]);
      return widget;
    }
  }
  
  return null;
}

// 主要的重定位函数
function repositionWishlist() {
  // 严格检查：如果已完成或正在处理，直接返回
  if (wishlistRepositioned) {
    console.log('⏭️ Already repositioned, skipping');
    return true;
  }
  
  if (isProcessing) {
    console.log('⏭️ Already processing, skipping');
    return false;
  }
  
  isProcessing = true; // 标记为正在处理
  
  repositionAttempts++;
  console.log('🔄 Reposition attempt #' + repositionAttempts);
  
  var widget = findWishlistWidget();
  
  if (!widget) {
    console.log('❌ Wishlist widget not found');
    isProcessing = false;
    
    // 如果还没达到最大次数，继续尝试
    if (repositionAttempts < maxAttempts) {
      console.log('⏳ Retrying in 500ms...');
      setTimeout(repositionWishlist, 500);
    } else {
      console.log('⏱️ Max attempts reached, stopping');
    }
    return false;
  }
  
  var isMobile = window.innerWidth < 750;
  console.log('📱 Device type:', isMobile ? 'Mobile' : 'Desktop', '| Width:', window.innerWidth);
  
  try {
    var success = false;
    if (isMobile) {
      success = repositionForMobile(widget);
    } else {
      success = repositionForDesktop(widget);
    }
    
    isProcessing = false;
    return success;
    
  } catch (error) {
    console.error('❌ Error during reposition:', error);
    isProcessing = false;
    return false;
  }
}

// 移动端处理
function repositionForMobile(widget) {
  var stickyContainer = document.querySelector('#sticky-wishlist-container');
  
  if (!stickyContainer) {
    console.log('❌ Sticky container not found');
    return false;
  }
  
  // 严格检查：是否已经有 wishlist 在 sticky bar 中
  var existingWidget = stickyContainer.querySelector('.gw-wl-add-to-wishlist-product-page-widget');
  if (existingWidget) {
    console.log('✅ Wishlist already in sticky bar (found existing)');
    wishlistRepositioned = true;
    return true;
  }
  
  // 二次确认：检查 sticky container 是否为空
  if (stickyContainer.children.length > 0) {
    console.log('⚠️ Sticky container not empty, clearing first');
    stickyContainer.innerHTML = ''; // 清空容器
  }
  
  console.log('📱 Cloning wishlist to sticky bar...');
  
  // 克隆整个 widget
  var clone = widget.cloneNode(true);
  
  // 给克隆的元素添加标记，防止被重复选中
  clone.setAttribute('data-wishlist-clone', 'true');
  
  stickyContainer.appendChild(clone);
  
  // 隐藏原始的 wishlist（如果它在产品信息区域）
  var originalBlock = widget.closest('.product__block') || widget.closest('.shopify-block');
  if (originalBlock && originalBlock.closest('.product__info-container')) {
    originalBlock.style.display = 'none';
    console.log('✅ Original wishlist hidden');
  }
  
  wishlistRepositioned = true;
  console.log('✅ Mobile: Wishlist successfully cloned to sticky bar!');
  return true;
}

// 桌面端处理
function repositionForDesktop(widget) {
  var buttonContainer = document.querySelector('.product__info-container .product-form__buttons');
  
  if (!buttonContainer) {
    console.log('❌ Button container not found');
    return false;
  }
  
  // 检查是否已经在按钮容器中
  if (buttonContainer.contains(widget)) {
    console.log('✅ Wishlist already in button container');
    wishlistRepositioned = true;
    return true;
  }
  
  console.log('💻 Moving wishlist to button container...');
  
  // 获取 widget 的父容器
  var widgetBlock = widget.closest('.product__block') || widget.closest('.shopify-block') || widget;
  
  // 移动到按钮容器
  buttonContainer.appendChild(widgetBlock);
  buttonContainer.classList.add('has-wishlist-button');
  widgetBlock.classList.add('wishlist-in-button-row');
  
  wishlistRepositioned = true;
  console.log('✅ Desktop: Wishlist successfully moved to button row!');
  return true;
}

// 窗口大小改变处理
var resizeTimer;
window.addEventListener('resize', function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
    console.log('📐 Window resized:', window.innerWidth);
    
    // 只在真正的设备切换时才重置
    var wasRepositioned = wishlistRepositioned;
    if (wasRepositioned) {
      console.log('⏭️ Already repositioned, ignoring resize');
      return;
    }
    
    // 重置状态并重新定位
    wishlistRepositioned = false;
    repositionAttempts = 0;
    isProcessing = false;
    repositionWishlist();
  }, 300);
});

// 防止滚动触发重复执行
var scrollBlocked = false;
window.addEventListener('scroll', function() {
  if (!scrollBlocked && wishlistRepositioned) {
    scrollBlocked = true;
    console.log('🚫 Scroll detected, but reposition already done');
  }
});

// 初始化 - 延迟启动避免与 Growave 冲突
function init() {
  console.log('⏰ Initializing in 1.5 seconds...');
  
  setTimeout(function() {
    console.log('🚀 Starting wishlist reposition...');
    repositionWishlist();
  }, 1500);
}

// 启动
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}